module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Template_16"],"path":[{"$":{"d":"M9.3,2,13,5v9H3V2H9m1-2H1V16H15V4L10,0Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Template_16.svg
// module id = MD3b
// module chunks = 1